import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2652584"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card card-body",
  style: {"height":"auto"}
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6 ModelField-colFirst" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Тип тягача", -1))
const _hoisted_6 = { class: "col-6 ModelField-colLast" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Тип полуприцепа", -1))
const _hoisted_8 = { style: {"margin-top":"30px"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"10px"} }, "Размеры в (мм), вес в (кг)", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  class: "collapse hide multi-collapse",
  style: {"margin-top":"20px"},
  ref: "collapseTractor",
  id: "collapseTractor"
}
const _hoisted_13 = { class: "card card-body" }
const _hoisted_14 = { class: "container-fluid" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-4 ModelField-colFirst" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Внутренняя длина (мм)", -1))
const _hoisted_18 = { class: "col-4 ModelField-col" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Внутренняя ширина (мм)", -1))
const _hoisted_20 = { class: "col-4 ModelField-colLast" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Внутренняя высота (мм)", -1))
const _hoisted_22 = { class: "container-fluid" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-6 ModelField-colFirst" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Грузоподъемность (кг)", -1))
const _hoisted_26 = { class: "col-6 ModelField-colLast" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Отступы", -1))
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-6 ModelField-colFirst" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Вес реквизита (кг)", -1))
const _hoisted_31 = { class: "col-6 ModelField-colLast" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Рекомендуемый порог статнагрузки (м³) ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Информация", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EnumControl = _resolveComponent("EnumControl")!
  const _component_TwoAxleTractorSingleAxleSemitrailer = _resolveComponent("TwoAxleTractorSingleAxleSemitrailer")!
  const _component_TwoAxleTractorTwoAxleSemitrailer = _resolveComponent("TwoAxleTractorTwoAxleSemitrailer")!
  const _component_TwoAxleTractorThreeAxleSemitrailer = _resolveComponent("TwoAxleTractorThreeAxleSemitrailer")!
  const _component_TwoAxleTractorFourAxleSemitrailer = _resolveComponent("TwoAxleTractorFourAxleSemitrailer")!
  const _component_ThreeAxleTractorSingleAxleSemitrailer = _resolveComponent("ThreeAxleTractorSingleAxleSemitrailer")!
  const _component_ThreeAxleTractorTwoAxleSemitrailer = _resolveComponent("ThreeAxleTractorTwoAxleSemitrailer")!
  const _component_ThreeAxleTractorThreeAxleSemitrailer = _resolveComponent("ThreeAxleTractorThreeAxleSemitrailer")!
  const _component_ThreeAxleTractorFourAxleSemitrailer = _resolveComponent("ThreeAxleTractorFourAxleSemitrailer")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_DecimalControl = _resolveComponent("DecimalControl")!
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_DxTextArea = _resolveComponent("DxTextArea")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_EnumControl, {
              class: "ModelField-control",
              id: _ctx.modelLocal.tractorType,
              "onUpdate:id": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelLocal.tractorType) = $event)),
              desc: _ctx.modelLocal.tractorTypeDescription,
              "onUpdate:desc": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelLocal.tractorTypeDescription) = $event)),
              enumType: "tractorType",
              stylingMode: "outlined",
              onChanged: _ctx.onTractorTypeChange
            }, null, 8, ["id", "desc", "onChanged"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_EnumControl, {
              class: "ModelField-control",
              id: _ctx.modelLocal.semitrailerType,
              "onUpdate:id": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelLocal.semitrailerType) = $event)),
              desc: _ctx.modelLocal.semitrailerTypeDescription,
              "onUpdate:desc": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelLocal.semitrailerTypeDescription) = $event)),
              enumType: "semitrailerType",
              stylingMode: "outlined",
              onChanged: _ctx.onSemitrailerTypeChange
            }, null, 8, ["id", "desc", "onChanged"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.twoAxleTractor && _ctx.singleAxleSemitrailer)
          ? (_openBlock(), _createBlock(_component_TwoAxleTractorSingleAxleSemitrailer, {
              key: 0,
              model: _ctx.modelLocal
            }, null, 8, ["model"]))
          : _createCommentVNode("", true),
        (_ctx.twoAxleTractor && _ctx.twoAxleSemitrailer)
          ? (_openBlock(), _createBlock(_component_TwoAxleTractorTwoAxleSemitrailer, {
              key: 1,
              model: _ctx.modelLocal
            }, null, 8, ["model"]))
          : _createCommentVNode("", true),
        (_ctx.twoAxleTractor && _ctx.threeAxleSemitrailer)
          ? (_openBlock(), _createBlock(_component_TwoAxleTractorThreeAxleSemitrailer, {
              key: 2,
              model: _ctx.modelLocal
            }, null, 8, ["model"]))
          : _createCommentVNode("", true),
        (_ctx.twoAxleTractor && _ctx.fourAxleSemitrailer)
          ? (_openBlock(), _createBlock(_component_TwoAxleTractorFourAxleSemitrailer, {
              key: 3,
              model: _ctx.modelLocal
            }, null, 8, ["model"]))
          : _createCommentVNode("", true),
        (_ctx.threeAxleTractor && _ctx.singleAxleSemitrailer)
          ? (_openBlock(), _createBlock(_component_ThreeAxleTractorSingleAxleSemitrailer, {
              key: 4,
              model: _ctx.modelLocal
            }, null, 8, ["model"]))
          : _createCommentVNode("", true),
        (_ctx.threeAxleTractor && _ctx.twoAxleSemitrailer)
          ? (_openBlock(), _createBlock(_component_ThreeAxleTractorTwoAxleSemitrailer, {
              key: 5,
              model: _ctx.modelLocal
            }, null, 8, ["model"]))
          : _createCommentVNode("", true),
        (_ctx.threeAxleTractor && _ctx.threeAxleSemitrailer)
          ? (_openBlock(), _createBlock(_component_ThreeAxleTractorThreeAxleSemitrailer, {
              key: 6,
              model: _ctx.modelLocal
            }, null, 8, ["model"]))
          : _createCommentVNode("", true),
        (_ctx.threeAxleTractor && _ctx.fourAxleSemitrailer)
          ? (_openBlock(), _createBlock(_component_ThreeAxleTractorFourAxleSemitrailer, {
              key: 7,
              model: _ctx.modelLocal
            }, null, 8, ["model"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", {
      class: "Tractor-switch",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSwitchChange && _ctx.onSwitchChange(...args))),
      "data-bs-toggle": "collapse",
      "data-bs-target": ".multi-collapse",
      "aria-expanded": "false",
      "aria-controls": "collapseTractor"
    }, [
      (_ctx.isSettingsOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_DxButton, {
              icon: "chevronup",
              "styling-mode": "outlined"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_DxButton, {
              icon: "chevrondown",
              "styling-mode": "outlined"
            })
          ]))
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Длина...",
                min: 0,
                value: _ctx.modelLocal.length,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelLocal.length) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Ширина...",
                min: 0,
                value: _ctx.modelLocal.width,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modelLocal.width) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_IntegerControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Высота...",
                min: 0,
                value: _ctx.modelLocal.height,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modelLocal.height) = $event))
              }, null, 8, ["value"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode(_component_DecimalControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Грузоподъемность...",
                decimalPoints: 2,
                min: 0,
                value: _ctx.modelLocal.loadCapacity,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modelLocal.loadCapacity) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_CatalogueSelectControl, {
                class: "ModelField-selectControl",
                stylingMode: "outlined",
                id: _ctx.modelLocal.gapId,
                "onUpdate:id": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modelLocal.gapId) = $event)),
                desc: _ctx.modelLocal.gapDescription,
                "onUpdate:desc": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modelLocal.gapDescription) = $event)),
                displayDescField: "name",
                keyField: "id",
                catalogueComponentName: "catalogues/GapCatalogue/GapCatalogue",
                hasEmptyValue: false,
                validationGroup: _ctx.validationGroup
              }, null, 8, ["id", "desc", "validationGroup"])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_DecimalControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Вес реквизита...",
                decimalPoints: 3,
                min: 0,
                value: _ctx.modelLocal.requisiteWeight,
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modelLocal.requisiteWeight) = $event))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createVNode(_component_DecimalControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Рекомендуемый порог статнагрузки...",
                decimalPoints: 3,
                min: 0,
                max: 100,
                value: _ctx.modelLocal.loadStatThreshold,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modelLocal.loadStatThreshold) = $event))
              }, null, 8, ["value"])
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_33,
          _createVNode(_component_DxTextArea, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Информация",
            value: _ctx.modelLocal.info,
            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modelLocal.info) = $event))
          }, null, 8, ["value"])
        ])
      ])
    ], 512)
  ]))
}